import React, { Component } from "react";
import "./TrackingMaster.css";
import { Select } from "antd";

import Moment from "react-moment";
import { Input } from "antd";
import Button from '@material-ui/core/Button';
import Plus from '../../Images/plus.png'
import dateFormat from 'dateformat';
import './DeliveryView.css'
import Paper from '@material-ui/core/Card'
import Labelbox from "../../helpers/labelbox/labelbox";
import ValidationLibrary from '../../helpers/ValidationLibrary/validationfunction';
import CustomizedSteppers from '../StepperStatus/Status'
import { apiurl } from "../../App";
import axiosInstance from "../../api/axiosInstance";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
export default class DeliveryView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time_interval:null,
      deliveryMode: null,
      timeValue: false,
      deliveryStatusUpdate: {
        'date': {
          'value': dateFormat(new Date(), "yyyy-mm-dd"),
          validation: [{ 'name': 'required' }],
          error: null,
          errmsg: null
        },
        'time': {
          'value': new Date(),
          validation: [{ 'name': 'required' }],
          error: null,
          errmsg: null
        },
      }
    };
  }

  componentDidMount() {
    clearInterval(this.state.time_interval)
    this.getDeliveryTrackingStatus()
    this.startTimer()
  }
  startTimer()
  {
    setInterval(() => {
      this.state.deliveryStatusUpdate.time.value=new Date();
      this.setState({})
    }, 10000);
  }

  getDeliveryTrackingStatus = () => {
    axiosInstance({
      method: 'POST',
      url: apiurl + 'pharmacy/viewOrderStatus',
      data: {
        order_id: this.props.orderId
      }
    }).then((response) => {
      this.setState({
        deliveryMode: response.data.data.filter(val => val.status_id != 1 && val.status_id != 2 && val.status_id != 4 && val.status_id != 7 ).find(data => data.ph_date === null) !== undefined ? response.data.data.filter(val => val.status_id != 1 && val.status_id != 2 && val.status_id != 4 && val.status_id != 7).find(data => data.ph_date === null) : response.data.data.filter(val => val.status_id != 1 && val.status_id != 2 && val.status_id != 4 && val.status_id != 7).find(data => data.status_id === 8),
        deliveryTrackingStatus: response.data.data,
      }, () => console.log(this.state.deliveryMode, "deliveryMode"))
    }).catch((error) => {
      console.log(error)
    })
  }

  checkValidation = (id) => {
    var deliveryStatusUpdate = this.state.deliveryStatusUpdate;
    var deliveryStatusUpdateKeys = Object.keys(deliveryStatusUpdate);
    console.log(deliveryStatusUpdateKeys);
    for (var i in deliveryStatusUpdateKeys) {
      var errorcheck = ValidationLibrary.checkValidation(
        deliveryStatusUpdate[deliveryStatusUpdateKeys[i]].value,
        deliveryStatusUpdate[deliveryStatusUpdateKeys[i]].validation
      );
      console.log(errorcheck);
      deliveryStatusUpdate[deliveryStatusUpdateKeys[i]].error = !errorcheck.state;
      deliveryStatusUpdate[deliveryStatusUpdateKeys[i]].errmsg = errorcheck.msg;
    }
    var filtererr = deliveryStatusUpdateKeys.filter(
      (obj) => deliveryStatusUpdate[obj].error == true
    );
    console.log(filtererr.length);
    if (filtererr.length > 0) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
      this.updateDeliveryStatus(id);
    }
    this.setState({ deliveryStatusUpdate });
  };

  changeDynamic = (data, key) => {
    if (key === "time") {
      this.setState({
        timeValue: true
      })
    }
    var deliveryStatusUpdate = this.state.deliveryStatusUpdate;
    var errorcheck = ValidationLibrary.checkValidation(data, deliveryStatusUpdate[key].validation);
    deliveryStatusUpdate[key].value = data;
    deliveryStatusUpdate[key].error = !errorcheck.state;
    deliveryStatusUpdate[key].errmsg = errorcheck.msg;
    this.setState({ deliveryStatusUpdate });
    this.setState({})
  }

  updateDeliveryStatus = (id) => {
    var date = dateFormat(this.state.deliveryStatusUpdate.date.value, "yyyy-mm-dd")
    var time = dateFormat(this.state.timeValue === true ? `${this.state.deliveryStatusUpdate.date.value} ${this.state.deliveryStatusUpdate.time.value}` : this.state.deliveryStatusUpdate.time.value, "HH:MM:ss")
    console.log(`${date} ${time}`, "sdfjslkdf")
    axiosInstance({
      method: 'POST',
      url: apiurl + 'pharmacy/updateOrderStatus',
      data: {
        order_id: this.props.orderId,
        date_time: `${date} ${time}`,
        status: id,
      }
    }).then((response) => {
      this.props.getTableData()
      this.props.closemodal(false)
    })
  }

  render() {
    return (
      <div className="delivery_view">
        <CustomizedSteppers deliveryTrackingStatus={this.state.deliveryTrackingStatus} />
        <div><p className="enter_tracking">Tracking</p></div>
        <div className="delivery_packing">
          <Paper className="pharpaper_container">
            <div className="outfor_butt"><Button className="outfor_deliverybutt">{this.state.deliveryMode !== null && this.state.deliveryMode.status}</Button></div>
            <div className="delivery_date">
              <div className="deli_timediv">
                  <div className="formdiv">
                    <label className="labeltxt">Date</label>
                    <div >

                      {/*<DatePicker value={moment(this.props.value)?moment(this.props.value):new Date()} open={this.state.open}  onFocus={()=>this.setState({open:true})} onChange={(date)=>this.datepickerChange(date)}  className="datepickerchnge" style={{width:'100%',}} format="YYYY-MM-DD"  />*/}
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar={false}
                          autoOk={true}
                          clearable={false}
                          disableUnderline={true}
                          minDateMessage=""
                          variant="dialog"
                          format="dd-MMM-yy"
                          margin="normal"
                          id="date-picker-inline"
                          value={this.state.deliveryStatusUpdate.date.value}
                          disablePast={true}
                          disabled="true"
                        />
                      </MuiPickersUtilsProvider>

                      {
                        this.state.deliveryStatusUpdate.date.error &&
                        <div className="Errormsg">
                          <span>{this.state.deliveryStatusUpdate.date.errmsg}</span>
                        </div>
                      }
                    </div>

                  </div>
                    {/* <Labelbox
                      type="datepicker"
                      labelname="Date"
                      // changeData={(data) => this.changeDynamic(data, 'date')}
                      value={this.state.deliveryStatusUpdate.date.value}
                      error={this.state.deliveryStatusUpdate.date.error}
                      errmsg={this.state.deliveryStatusUpdate.date.errmsg}
                      disablePast
                    /> */}
              </div>
            <div className="deli_timediv">
                <div className="formdiv">
                    <label className="labeltxt">Time</label>
                    <div >

                      {/*<TimePicker value={this.props.value} onChange={(time)=>this.onChange(time)} />*/}
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                          disabled="true"
                          margin="normal"
                          id="time-picker"
                          value={this.state.deliveryStatusUpdate.time.value}
                          //onChange={(time) => this.timepickerChange(time)}
                          KeyboardButtonProps={{
                            'aria-label': 'change time',
                          }}
                        />
                      </MuiPickersUtilsProvider>
                      {
                        this.state.deliveryStatusUpdate.time.error &&
                        <div className="Errormsg">
                          <span>{this.state.deliveryStatusUpdate.time.errmsg}</span>
                        </div>
                      }
                    </div>

                  </div>
                {/* <Labelbox
                  type="timepicker"
                  labelname="Time"
                  changeData={(data) => this.changeDynamic(data, 'time')}
                  value={this.state.deliveryStatusUpdate.time.value}
                  error={this.state.deliveryStatusUpdate.time.error}
                  errmsg={this.state.deliveryStatusUpdate.time.errmsg}
                  railwayTime
                  readonly
                /> */}
              </div>
            </div>
          </Paper>
        </div>
        {
          this.state.deliveryMode !== null && this.state.deliveryMode.ph_date === null &&
          <div className="modalbutt_container"><div><div><Button className="cancel_buttphar" variant="contained" onClick={() => this.props.closemodal(false)}>Cancel</Button></div></div>
            <div><div><Button className="update_button" variant="contained" color="primary" onClick={() => this.checkValidation(this.state.deliveryMode.status_id)}>Submit</Button></div></div>
          </div>
        }
      </div>
    );
  }
}


